import { action, computed, makeAutoObservable, runInAction } from "mobx";
import { Coupon, CouponData, CouponType, } from "../../../services/coupons/models";
import { createCoupon, deleteCoupon, getCoupons, updateCoupon } from "../../../services/coupons";
import { Menu } from "../../../services/menu/models";
import { getMenus } from "../../../services/menu";
import CouponsFormsStore from "./forms";


class CouponsStore {

    limit: number = 20;
    total: number;
    menusIds: number[] = [];
    skip: number = 0;
    page: number = 1;
    pages: number = 1;
    coupons: Coupon[];
    menusList: Menu[] = [];
    forms = new CouponsFormsStore();
    couponType: CouponType = CouponType.all;
    activationsByCoupon: {[s: number]: number}




    @action
    setCouponType(couponType: CouponType) {
        this.couponType = couponType;
    }

    @action
    setLimit(limit: number) {
        this.limit = limit;
    }

    @action
    setSkip(skip: number) {
        this.skip = skip;
    }

    @action
    setPage(page: number) {
        this.page = page;
    }

    @action
    setPages(pages: number) {
        this.pages = pages;
    }

    @action
    setMenusIds(menusIds: number[]) {
        this.menusIds = menusIds;
    }

    @computed
    getCouponType() {
        return this.couponType;
    }

    @computed
    getMenusIds() {
        return this.menusIds;
    }

    @computed
    getPage() {
        return this.page;
    }

    @computed
    getPages() {
        return this.pages;
    }

    @computed
    getLimit() {
        return this.limit;
    }

    @computed
    getSkip() {
        return this.skip;
    }

    @computed
    getActivationsByCoupon(id: number){
        return this.activationsByCoupon[id] || 0;
    }

    async init() {
        const menusResponse = await getMenus();
        runInAction(() => {
            this.menusList = menusResponse.menus;
            if (this.menusList.length !== 0 && this.menusIds.length === 0) {
                this.menusIds = [this.menusList[0].id];
            }
        });
    }

    getMenuById(menuId: number): Menu | undefined {
        return this.menusList.find(item => item.id === menuId);
    }


    async getCoupons() {
        const type = this.getCouponType();
        const response = await getCoupons({
            skip: this.skip,
            limit: this.limit,
            menusIds: this.menusIds,
            types: type === CouponType.all ? [] : [type],
            activatedByClientsIds: [],
            isActive: null,
            isRemoved: false
        });
        runInAction(() => {
            this.coupons = response.coupons;
            this.total = response.total;
            this.pages = Math.ceil(this.total / this.getLimit());
            this.activationsByCoupon = response.activationsByCouponId;

        });
    }

    async createCoupon(data: CouponData) {
        const response = await createCoupon({ data: data, menuId: this.menusIds[0] });
        this.getCoupons();
        return response;
    }

    async deleteCoupon(couponId: number) {
        const response = await deleteCoupon({ couponId: couponId });
        this.setPage(1);
        this.setSkip(0);
        this.getCoupons();
        return response;
    }

    async updateCoupon(data: CouponData, couponId: number) {
        const response = await updateCoupon({ data: data, couponId: couponId });
        this.getCoupons();
        return response;
    }

    constructor() {
        makeAutoObservable(this);
        this.deleteCoupon = this.deleteCoupon.bind(this);
        this.updateCoupon = this.updateCoupon.bind(this)
    }

}


export default CouponsStore;
